import { render } from "./CreateCompanyServicesProductsSetup.vue?vue&type=template&id=ab3d4558"
import script from "./CreateCompanyServicesProductsSetup.vue?vue&type=script&lang=js"
export * from "./CreateCompanyServicesProductsSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__